<template>
	<modal name="auth-modal" class="auth-modal" @closed="isLogin=true; hideAuthModal(false);" transition="scale">
		<div class="auth-modal-close" @click="isLogin=true; hideAuthModal(true)">
			<i class='bx bx-x'></i>
		</div>
		<div class="auth-modal-content">
			<transition name="scale" mode="out-in">
				<login-form @success="loginSuccess" @forgotPassword="isLogin = false" v-if="isLogin"></login-form>
				<forgot-password-request-form v-if="!isLogin" @backToLogin="isLogin = true"></forgot-password-request-form>
			</transition>
		</div>
	</modal>
</template>

<script>
	import { createNamespacedHelpers } from "vuex";
	import LoginForm from './LoginForm.vue';
	import ForgotPasswordRequestForm from './ForgotPasswordRequestForm.vue'

	const { mapState, mapActions } = createNamespacedHelpers('AuthModule');

	export default {
		data(){
			return{
				isLogin: true
			}
		},
		components: {
			LoginForm,
			ForgotPasswordRequestForm
		},
		computed: {
			...mapState({
				visibility: state => state.authModal.visibility,
				callbackAction: state => state.authModal.callbackAction
			})
		},
		watch: {
			visibility(newVal) {
				newVal ? this.$modal.show('auth-modal') : this.$modal.hide('auth-modal');
			}
		},
		methods: {
			...mapActions(['hideAuthModal']),
			callback() {
				this.$store.dispatch(
					this.callbackAction.name,
					this.callbackAction.payload
				);
			},
			loginSuccess() {
				this.callback();
				this.hideAuthModal(true);
			}
		}
	}
</script>